/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/
import { DashboardOptions } from '@uppy/dashboard';
import { ImageEditorOptions } from '@uppy/image-editor';

/**
 * Uppy dahsboard option.
 */
export const UPPY_DASHBOARD_OPTIONS: DashboardOptions = {
  showProgressDetails: true,
  closeModalOnClickOutside: false,
  closeAfterFinish: true,
  proudlyDisplayPoweredByUppy: false,
  autoOpenFileEditor: true,
  browserBackButtonClose: false,
  disableThumbnailGenerator: false,
  hideCancelButton: true,
  disableStatusBar: true,
  target: '#uppy-target',
};

/**
 * Uppy image editor option.
 */
export const UPPY_IMAGE_EDITOR_OPTION: ImageEditorOptions = {
  id: 'ImageEditor',
  quality: 0.8,
  cropperOptions: {
    viewMode: 0,
    autoCrop: true,
    responsive: true,
    aspectRatio: 1,
    croppedCanvasOptions: {
      fillColor: '#fff',
    },
  },
  actions: {
    revert: false,
    rotate: true,
    granularRotate: false,
    flip: false,
    zoomIn: false,
    zoomOut: false,
    cropSquare: false,
    cropWidescreen: false,
    cropWidescreenVertical: false,
  },
};

/**
 * Supported image formats
 */
export const SUPPORTED_FORMATS = {
  IMAGE: 'image/bmp,image/webp,image/jpeg,image/gif,image/png',
};

/**
 * Language map for loading correct translation file.
 */
export const languageMap = {
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fi: 'fi_FI',
  fr: 'fr_FR',
  nl: 'nl_NL',
  no: 'nb_NO',
  pt: 'pt_PT',
  sv: 'sv_SE',
};
